import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useRef } from 'react';
import { useAtom as useAtomOrig, useAtomValue as useAtomValueOrig, useSetAtom as useSetAtomOrig, useStore as useStoreOrig, } from 'jotai/react';
import { useHydrateAtoms } from 'jotai/react/utils';
import { createStore } from 'jotai/vanilla';
export function createIsolation() {
    const StoreContext = createContext(null);
    function Provider({ store, initialValues = [], children, }) {
        const storeRef = useRef(store);
        if (!storeRef.current) {
            storeRef.current = createStore();
        }
        useHydrateAtoms(initialValues, { store: storeRef.current });
        return (_jsx(StoreContext.Provider, { value: storeRef.current, children: children }));
    }
    const useStore = ((options) => {
        const store = useContext(StoreContext);
        if (!store)
            throw new Error('Missing Provider from createIsolation');
        return useStoreOrig({ store, ...options });
    });
    const useAtom = ((anAtom, options) => {
        const store = useStore();
        return useAtomOrig(anAtom, { store, ...options });
    });
    const useAtomValue = ((anAtom, options) => {
        const store = useStore();
        return useAtomValueOrig(anAtom, { store, ...options });
    });
    const useSetAtom = ((anAtom, options) => {
        const store = useStore();
        return useSetAtomOrig(anAtom, { store, ...options });
    });
    return { Provider, useStore, useAtom, useAtomValue, useSetAtom };
}
//# sourceMappingURL=createIsolation.js.map